import { createElementBlock as l, openBlock as t, createElementVNode as c } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function o(r, e) {
  return t(), l("svg", n, e[0] || (e[0] = [
    c("path", {
      fill: "#00DC82",
      d: "M13.32 19.333h8.14c.26 0 .508-.09.733-.22.226-.129.457-.29.587-.513s.22-.476.22-.733c0-.258-.09-.51-.22-.734l-5.5-9.46a1.34 1.34 0 0 0-.513-.513 1.8 1.8 0 0 0-.807-.22c-.26 0-.508.09-.733.22-.216.12-.393.298-.514.513l-1.393 2.42L10.533 5.4c-.13-.223-.288-.458-.513-.587s-.474-.146-.733-.146c-.26 0-.509.018-.734.146-.24.146-.441.347-.586.587l-6.82 11.733c-.13.223-.147.476-.147.734 0 .257.017.51.147.733s.361.384.586.513c.225.13.474.22.734.22H7.6c2.034 0 3.515-.912 4.547-2.64l2.493-4.326 1.32-2.274 4.033 6.894H14.64zm-5.793-2.346H3.933l5.354-9.24L12 12.367l-1.797 3.132c-.687 1.122-1.468 1.488-2.676 1.488"
    }, null, -1)
  ]));
}
const d = { render: o };
export {
  d as default,
  o as render
};
